import React, { useState, useEffect } from "react";
import { TypeAnimation } from "react-type-animation";
import { NavLink } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

const Spinner = () => (
  <div className="flex justify-center pt-2 items-center">
    <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-8 w-8"></div>
  </div>
);

const SearchBar = ({ placeholderColor, countries, onCountrySelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setLoading(true);
    setTimeout(() => {
      if (value) {
        const filtered = countries.filter((country) =>
          country.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredCountries(filtered);
      } else {
        setFilteredCountries([]);
      }
      setLoading(false);
    }, 1500); // Delay of 1.5 seconds
  };

  const handleCountryClick = (country) => {
    onCountrySelect(country);
    setInputValue(""); // Clear the input
    setFilteredCountries([]); // Clear the search results
  };

  return (
    <div className="relative h-14 w-full max-w-lg mx-auto mt-10">
      <div className="relative">
        <FaSearch className="absolute top-1/2 right-6 transform -translate-y-1/2 text-gray-200" />
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          className="w-full p-3 pl-10 border-2 border-gray-300 text-lg rounded-lg bg-transparent focus:outline-none"
          placeholder=""
          style={{
            color: "white",
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        />
        {inputValue === "" && (
          <div className="absolute inset-y-0 left-10 pl-0 flex items-center pointer-events-none">
            <span
              className="mr-2 text-gray-200"
              style={{
                fontFamily: "Arial, sans-serif",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Search For
            </span>
            <TypeAnimation
              sequence={[
                "Maldives",
                1000,
                "Dubai",
                1000,
                "Malaysia",
                1000,
                "Brazil",
                1000,
              ]}
              wrapper="span"
              cursor={true}
              repeat={Infinity}
              style={{
                color: "#5b53fb",
                fontFamily: "Arial, sans-serif",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            />
          </div>
        )}
      </div>
      {loading && <Spinner />}
      {filteredCountries.length > 0 && (
        <ul className="absolute left-0 right-0 mt-2 bg-white border border-gray-300 rounded-lg max-h-60 overflow-y-auto z-10 shadow-lg">
          {filteredCountries.map((country) => (
            <li
              key={country.name}
              className="p-2 cursor-pointer hover:bg-gray-200 flex items-center"
              onClick={() => handleCountryClick(country)}
            >
              <NavLink
                to={`/packages/${country.title}`}
                className="flex items-center"
              >
                <img
                  src={country.icon}
                  alt={country.name}
                  className="w-6 h-6 mr-2"
                />
                <span className="text-gray-700">{country.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
      {inputValue && filteredCountries.length === 0 && !loading && (
        <ul className="absolute left-0 right-0 mt-2 bg-white border border-gray-300 rounded-lg max-h-60 overflow-y-auto z-10 shadow-lg">
          <li
            className="p-2 flex justify-start cursor-pointer hover:bg-gray-200"
            onClick={() =>
              handleCountryClick({ name: inputValue, title: inputValue })
            }
          >
            {inputValue}
          </li>
        </ul>
      )}
    </div>
  );
};

export default SearchBar;
